var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-clock",
    "data-name": "Icon feather-clock",
    transform: "translate(-2.5 -2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6624",
    "data-name": "Path 6624",
    d: "M17,10a7,7,0,1,1-7-7,7,7,0,0,1,7,7Z",
    fill: "none",
    stroke: "#3acce1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6625",
    "data-name": "Path 6625",
    d: "M18,9v3.965l3.965,1.322",
    transform: "translate(-8.982 -1.977)",
    fill: "none",
    stroke: "#3acce1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.846572e48117499cd65253d199b2a2ee.svg";
export { ForwardRef as ReactComponent };